import React from 'react'
import { CourseContainer } from './styled'
import Article from 'components/Article'
import CourseVideo from 'components/CourseVideo'
import CourseAudio from 'components/CourseAudio'
import CoursePdf from 'components/CoursePdf'
import WistiaPlayer from 'components/WistiaPlayer'

export default function CourseContent({ course, modules, progressField }) {

  return (
    <>
      <CourseContainer transparent={course?.type === "video"}>
        {course?.type !== "article" ? null : <Article course={course} />}
        {/* {course?.type !== "video" ? null : <CourseVideo course={course} />} */}
        {course?.type !== "video" ? null : <WistiaPlayer course={course} modules={modules} progressField={progressField} />}
        {course?.type !== "audio" ? null : <CourseAudio course={course} />}
        {course?.type !== "pdf" ? null : <CoursePdf course={course} />}
        {course?.type !== "documents" ? null : <CoursePdf course={course} />}
      </CourseContainer>
    </>
  )
}
